var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{directives:[{name:"show",rawName:"v-show",value:(_vm.haveGeoloc),expression:"haveGeoloc"}],attrs:{"lat-lng":_vm.userPosition,"icon":_vm.getUserIconPosition(_vm.color1, _vm.color2)}})}
var staticRenderFns = []

export { render, staticRenderFns }